<template>
  <div
    :class="DS_FILE_UPLOAD_CLASSES.Files"
    data-cy="ds-file-upload__files"
    @click.stop
  >
    <DSFileUploadFileItem
      v-for="item in props.items"
      :key="item.id"
      :item="item"
      :disabled="props.disabled"
      @remove="emit('remove', $event)"
    />

    <DSDivider
      :class="DS_FILE_UPLOAD_CLASSES.Divider"
      data-cy="ds-file-upload__divider"
    />

    <DSButton
      :class="DS_FILE_UPLOAD_CLASSES.RemoveAll"
      variant="ghost"
      prefix-icon="bin"
      size="sm"
      type="button"
      :disabled="props.disabled"
      @click.stop="emit('remove-all')"
    >
      {{ removeAllText }}
    </DSButton>
  </div>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import DSFileUploadFileItem from "./DSFileUploadFileItem.vue";
import { DS_FILE_UPLOAD_CLASSES } from "../constants/classes";
import type { DSFileUploadItem } from "../types";
import DSDivider from "../../../layouts_and_containers/divider/components/DSDivider.vue";

interface DSFileUploadFileListProps {
  items: DSFileUploadItem[];
  disabled: boolean;
}

interface DSFileUploadFileListEmits {
  (e: "remove", item: DSFileUploadItem): void;
  (e: "remove-all"): void;
}

const props = defineProps<DSFileUploadFileListProps>();
const emit = defineEmits<DSFileUploadFileListEmits>();
const removeAllText = window.I18n.designSystem.fileUpload.removeAll;
</script>
